import { useEffect, useState } from "react";
import { EVENT } from "../config";

function getTimeLeft(target) {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label}`}>
    <span className="font-display text-4xl md:text-6xl font-light tabular-nums text-[#3F3A32]">
      {String(value).padStart(2, "0")}
    </span>
    <span className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#7A7264]">
      {label}
    </span>
  </div>
);

export const Countdown = () => {
  const [time, setTime] = useState(getTimeLeft(EVENT.date));

  useEffect(() => {
    const id = setInterval(() => setTime(getTimeLeft(EVENT.date)), 1000);
    return () => clearInterval(id);
  }, []);

  if (!time) {
    return (
      <p
        className="font-display text-2xl md:text-3xl text-[#7A6A5E]"
        data-testid="countdown-finished"
      >
        The party has started – welcome!
      </p>
    );
  }

  return (
    <div className="flex items-start gap-5 md:gap-10" data-testid="countdown">
      <Unit value={time.days} label="days" />
      <span className="font-display text-3xl md:text-5xl text-[#AFA58F]">:</span>
      <Unit value={time.hours} label="hours" />
      <span className="font-display text-3xl md:text-5xl text-[#AFA58F]">:</span>
      <Unit value={time.minutes} label="minutes" />
      <span className="font-display text-3xl md:text-5xl text-[#AFA58F]">:</span>
      <Unit value={time.seconds} label="seconds" />
    </div>
  );
};
